export const PageMode = {
  MySessions: 10,
  AllSessions: 20,
  PublishedSessions: 30,
}
